module.exports = __webpack_public_path__ + "static/media/withBackground.9578aff7.svg";